import script from "./SocialMessageComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialMessageComposer.vue?vue&type=script&setup=true&lang=ts"

import "./SocialMessageComposer.vue?vue&type=style&index=0&id=db0cf6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db0cf6bc"]])

export default __exports__